/**
 * TanStack Query hooks for `igaming-chargeback-refund-events`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingChargebackRefundEventsQueryKeys,
	type CreateIgamingChargebackRefundEventsBody,
	type ListIgamingChargebackRefundEventsResponse,
	type IgamingChargebackRefundEventsRow,
} from "./api";

export function useIgamingChargebackRefundEventsList(): UseQueryResult<ListIgamingChargebackRefundEventsResponse, Error> {
	return useQuery({
		queryKey: igamingChargebackRefundEventsQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingChargebackRefundEventsCreate(): UseMutationResult<IgamingChargebackRefundEventsRow, Error, CreateIgamingChargebackRefundEventsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingChargebackRefundEventsQueryKeys.all });
		},
	});
}

export function useIgamingChargebackRefundEventsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingChargebackRefundEventsQueryKeys.all });
		},
	});
}
